import History from "../components/about/history/history"
import Main from "../components/about/main/main"
import More from "../components/about/seeMore/More"
import Value from "../components/about/value/value"
import WayForward from "../components/about/wayForward/wayForward"
import News from "../components/about/worldInTraum/news"
import Footer from "../components/footer/footer"

const About = () => {
  return(
    <>
      <Main />
      <WayForward />
      <News />
      <Value />
      <History />
      <More />
      <Footer />
    </>
  )
}

export default About